import React from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Briefcase, AlertCircle, Clock } from 'lucide-react';

const localizer = momentLocalizer(moment);

export default function JobsCalendar({ jobs, onSelectJob }) {
  const events = jobs.map(job => {
    // If completed, span from start to complete. Else just put due date.
    let start = new Date(job.created_at);
    let end = job.completed_at ? new Date(job.completed_at) : (job.due_date ? new Date(job.due_date) : start);
    
    // Ensure all jobs have valid dates
    if (end < start) end = start;

    return {
      id: job.id,
      title: `${job.job_number} - ${job.title}`,
      start,
      end,
      allDay: true,
      job
    };
  });

  const eventStyleGetter = (event) => {
    const status = event.job.status;
    let backgroundColor = 'var(--text-muted)';
    let borderLeft = '4px solid #333';
    let blockOpacity = 0.9;
    
    if (status === 'completed') { backgroundColor = '#10B98122'; borderLeft = '4px solid #10B981'; } // Emerald
    else if (status === 'in_progress') { backgroundColor = '#F59E0B22'; borderLeft = '4px solid #F59E0B'; } // Amber
    else if (status === 'assigned') { backgroundColor = '#8B5CF622'; borderLeft = '4px solid #8B5CF6'; } // Violet
    else if (status === 'pending') { backgroundColor = '#3B82F622'; borderLeft = '4px solid #3B82F6'; } // Blue
    else if (status === 'forecasted') { 
      backgroundColor = 'transparent'; 
      borderLeft = '4px dashed var(--text-muted)';
      blockOpacity = 0.6;
    }

    if (event.job.priority === 'critical') borderLeft = '4px solid #EF4444'; // Override critical
    else if (event.job.job_type === 'preventive') borderLeft = '4px solid #F97316'; // Override preventive

    return {
      style: {
        backgroundColor,
        borderRadius: '0 4px 4px 0',
        opacity: blockOpacity,
        color: 'var(--text)',
        border: '0px',
        borderLeft,
        display: 'block',
        fontSize: '11px',
        fontWeight: '600'
      }
    };
  };

  return (
    <div style={{ height: '70vh', background: 'var(--bg-card)', padding: 20, borderRadius: 'var(--r-lg)', border: '1px solid var(--border)', display: 'flex', flexDirection: 'column' }}>
      <div style={{ display:'flex', gap:12, marginBottom:16, flexWrap:'wrap' }}>
        <div style={{ display:'flex', alignItems:'center', gap:6, fontSize:12, color:'var(--text-muted)' }}>
          <div style={{ width:12, height:12, borderRadius:'50%', background:'#8B5CF6' }}></div> Assigned
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:6, fontSize:12, color:'var(--text-muted)' }}>
          <div style={{ width:12, height:12, borderRadius:'50%', background:'#F59E0B' }}></div> In Progress
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:6, fontSize:12, color:'var(--text-muted)' }}>
          <div style={{ width:12, height:12, borderRadius:'50%', background:'#10B981' }}></div> Completed
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:6, fontSize:12, color:'var(--text-muted)', marginLeft:'auto' }}>
          <AlertCircle size={14} color="#EF4444" /> Critical
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:6, fontSize:12, color:'var(--text-muted)' }}>
          <Clock size={14} color="#F97316" /> Preventive Maintenance
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:6, fontSize:12, color:'var(--text-muted)' }}>
          <div style={{ width:12, height:12, border:'2px dashed var(--text-muted)', borderRadius:'50%' }}></div> Planned (Forecast)
        </div>
      </div>
      
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        style={{ flex: 1 }}
        eventPropGetter={eventStyleGetter}
        onSelectEvent={(e) => onSelectJob(e.job)}
        views={['month', 'week', 'day']}
        defaultView="month"
      />
    </div>
  );
}
